module.exports = __webpack_public_path__ + "57cdd426225124a19d014814e24e2170.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_arrowdown.svg
// module id = 1165
// module chunks = 0